import { Component, input, output } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import {
    lucideChevronRight,
    lucideArrowRight,
    lucideTrophy,
    lucideHelpCircle,
} from '@ng-icons/lucide'
import {
    HeaderMenuType,
    DealGroup,
    FunActivity,
} from '../../header-client.types'

@Component({
    selector: 'app-header-client-mega-menu',
    imports: [RouterModule, NgIcon],
    providers: [
        provideIcons({
            lucideChevronRight,
            lucideArrowRight,
            lucideTrophy,
            lucideHelpCircle,
        }),
    ],
    templateUrl: './header-client-mega-menu.component.html',
    styleUrl: './header-client-mega-menu.component.css',
})
export class HeaderClientMegaMenuComponent {
    activeMenu = input<HeaderMenuType | null>(null)
    dealGroups = input<DealGroup[]>([])
    funActivities = input<FunActivity[]>([])

    menuClose = output<void>()
    menuEnter = output<void>()
    menuLeave = output<void>()

    onMouseEnter() {
        this.menuEnter.emit()
    }

    onMouseLeave() {
        this.menuLeave.emit()
    }

    onClose() {
        this.menuClose.emit()
    }
}
